import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    actionsColumnKey,
    bonusReportKey,
    bpiStatusColumnKey,
    closedColumnKey,
    closedOptionsPriceColumnKey,
    closedPositionKey,
    closedPositionsTitle,
    closedStockPriceColumnKey,
    dmtLessonsKey,
    dmtProductKey,
    initiatedColumnKey,
    initiatedKey,
    lastCloseColumnKey,
    marketRelativeStrengthColumnKey,
    modelPortfolioKey,
    openedOptionsPriceColumnKey,
    openedPositionKey,
    openedStockPriceColumnKey,
    openPositionsTitle,
    optionsGainsColumnKey,
    peerRelativeStrengthColumnKey,
    sectorColumnKey,
    sectorRelativeStrengthColumnKey,
    stanceColumnKey,
    stockGainsColumnKey,
    symbolColumnKey,
    tradeAlertKey,
    webinarKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    configureProductPortfolioActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = modelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: dmtProductKey,
    modelPortfolioKeys: [
        {
            key: openedPositionKey,
            title: openPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                stanceColumnKey,
                sectorColumnKey,
                lastCloseColumnKey,
                bpiStatusColumnKey,
                sectorRelativeStrengthColumnKey,
                peerRelativeStrengthColumnKey,
                marketRelativeStrengthColumnKey,
                initiatedColumnKey,
                openedStockPriceColumnKey,
                openedStockPriceColumnKey,
                actionsColumnKey
            ]
        },
        {
            key: closedPositionKey,
            title: closedPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                sectorColumnKey,
                initiatedColumnKey,
                closedColumnKey,
                openedStockPriceColumnKey,
                closedStockPriceColumnKey,
                stockGainsColumnKey,
                openedOptionsPriceColumnKey,
                closedOptionsPriceColumnKey,
                optionsGainsColumnKey,
                actionsColumnKey
            ]
        }
    ]
}

const productActionTopicKeys = [
    bonusReportKey,
    modelPortfolioKey,
    tradeAlertKey,
    webinarKey,
    dmtLessonsKey
];

export function useDeepMarketTrader() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( dmtProductKey, productActionTopicKeys );
    const portfolioActionsMap =
        configureProductPortfolioActionsMap(
            'DMT', initiatedKey, closedPositionKey,
            productConfig.modelPortfolioKeys![ 0 ], productConfig.modelPortfolioKeys![ 1 ] );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        portfolioActionsMap,
        selectedView
    }
}
